import { ACCOUNT_SETTINGS_PAGES } from '../../../routing/routeConfiguration';

const ACCOUNT_SETTINGS_MENU_EXCLUDED_PAGES = ['SellerVerificationPage', 'AdminVerificationPage'];

const isAccountSettingsPage = currentPage =>
  ACCOUNT_SETTINGS_PAGES.includes(currentPage) &&
  !ACCOUNT_SETTINGS_MENU_EXCLUDED_PAGES.includes(currentPage);

const isTransactionsPageMatch = (currentPage, page) =>
  currentPage?.indexOf('TransactionsPage') === 0 && page?.indexOf('TransactionsPage') === 0;

export const isTopbarMenuPageActive = (currentPage, page) => {
  if (!currentPage || !page) {
    return false;
  }

  return (
    currentPage === page ||
    (page === 'AccountSettingsPage' && isAccountSettingsPage(currentPage)) ||
    isTransactionsPageMatch(currentPage, page)
  );
};

